import React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import './Tabs.css';

export default function Tabs({ tabItems }) {
    const [value, setValue] = React.useState("0");

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleChange} aria-label="lab API tabs example" variant="scrollable" scrollButtons="auto"
                        sx={{
                            '& .MuiTab-root': { fontFamily: 'Poppins', color: 'black', textTransform: 'none' },
                            '& .Mui-selected': { color: 'black', fontFamily: 'Poppins', fontWeight: 'bold', },
                            '& .MuiTabs-indicator': { backgroundColor: '#E34242' },
                            overflowX: 'auto',
                            whiteSpace: 'nowrap',
                        }}>
                        {tabItems?.map((item, idx) => {
                            return <Tab style={{ color: 'black' }} label={item.label} value={String(idx)} key={idx} />
                        })}
                    </TabList>
                </Box>
                {tabItems?.map((item, idx) => {
                    return <TabPanel value={String(idx)} key={idx}>{item.component}</TabPanel>
                })}
            </TabContext>
        </Box>
    );
}
